export default __webpack_public_path__ + "static/restaurant-db96c1902a091715dd13c421c84cbb7b.jpg";